module.exports = __webpack_public_path__ + "img/cafe&Barcall_logo.d14b7823.png";